import React from 'react';

export interface Category {
  name: string;
  emoji: string;
}

interface CategoryFiltersProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
  className?: string;
  scrollable?: boolean;
}

const ChevronRight: React.FC = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0">
    <path d="M4.5 2.5L7.5 6L4.5 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PillButtons: React.FC<{ categories: Category[]; activeCategory: string; onCategoryChange: (c: string) => void }> = ({
  categories, activeCategory, onCategoryChange,
}) => (
  <>
    <button
      type="button"
      onClick={() => onCategoryChange('All')}
      className={`flex-shrink-0 px-3 py-1.5 text-sm font-medium rounded-full border transition-all duration-200 ${
        activeCategory === 'All'
          ? 'bg-primary text-white border-primary shadow-md'
          : 'bg-white text-gray-700 border-gray-300 hover:bg-blue-50'
      }`}
    >
      Tout
    </button>
    {categories.map((category) => (
      <button
        key={category.name}
        type="button"
        onClick={() => onCategoryChange(category.name)}
        className={`flex-shrink-0 px-3 py-1.5 text-sm font-medium rounded-full border transition-all duration-200 ${
          activeCategory === category.name
            ? 'bg-primary text-white border-primary shadow-md'
            : 'bg-white text-gray-700 border-gray-300 hover:bg-blue-50'
        }`}
      >
        <span className="mr-1">{category.emoji}</span>
        {category.name}
      </button>
    ))}
  </>
);

export const CategoryFilters: React.FC<CategoryFiltersProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
  className = '',
  scrollable = false,
}) => {
  if (!scrollable) {
    return (
      <div className={`flex flex-wrap gap-2 ${className}`}>
        <PillButtons categories={categories} activeCategory={activeCategory} onCategoryChange={onCategoryChange} />
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <div className="overflow-hidden">
        <div className="flex overflow-x-auto gap-2 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <PillButtons categories={categories} activeCategory={activeCategory} onCategoryChange={onCategoryChange} />
          <span className="flex-shrink-0 w-6" aria-hidden="true" />
        </div>
      </div>
      <div className="absolute right-0 top-0 bottom-1 w-8 bg-gradient-to-l from-gray-50 via-gray-50/80 to-transparent pointer-events-none flex items-center justify-end text-gray-400">
        <ChevronRight />
      </div>
    </div>
  );
};
